// Drive maintenance API — reconciliation trigger (Phase 5 FE).
//
// USE_REAL_API-gated. Real → POST /drive/admin/reconcile (admin Ring 3); maket →
// MSW sim. Returns the reconciliation report (orphan sweep + retention purge +
// integrity), with the D2 purge gate reflected via `purge_gated`.

import { apiUrl } from '../lib/api'

export type ReconcileReport = {
  expired_orphans_purged: number
  stale_reconciled: number
  scanned: number
  bytes_purged: number
  purge_gated?: boolean
  integrity?: {
    checked?: number
    rows_without_bytes?: string[]
    folders_unreadable?: number
    skipped?: string
  }
}

export async function runReconcile(opts?: {
  includeIntegrity?: boolean
  forcePurge?: boolean
}): Promise<ReconcileReport> {
  const params = new URLSearchParams()
  if (opts?.includeIntegrity != null)
    params.set('include_integrity', String(opts.includeIntegrity))
  if (opts?.forcePurge != null) params.set('purge', String(opts.forcePurge))
  const qs = params.toString()
  const res = await fetch(apiUrl(`/drive/admin/reconcile${qs ? `?${qs}` : ''}`), {
    method: 'POST',
  })
  if (!res.ok) {
    const err = await res.json().catch(() => null)
    throw new Error(err?.detail?.message ?? `reconcile failed: ${res.status}`)
  }
  return res.json()
}
